<template>
	<div class="simulationsSearch">
		<div class="searchArea">
			<div class="container">
				<div class="searchInputWrapper">
					<input
						class="searchInput"
						:placeholder="$t('Pesquise uma simulação...')"
						v-model="searchStr"
					/>

					<input
						class="searchInputAutoComplete"
						:value="autoComplete"
						tabindex="-1"
					/>

					<div class="searchInputBtnIconBox">
						<button
							class="searchInputClearFieldBtn"
							v-if="searchStr !== ''"
							@click="() => (searchStr = '')"
						>
							<BIcon name="CloseFilled" />
						</button>
						<BIcon class="searchInputIcon" name="Search" />
					</div>
				</div>
				<div class="totalResults">
					{{
						$t("${totalResults} resultados disponíveis", {
							totalResults: this.simulationSummaries.length,
						})
					}}
				</div>
			</div>

			<div class="searchResults" v-if="searchStr !== ''">
				<template v-if="searchResults.length">
					<div
						v-for="searchResultItem in searchResults"
						:key="searchResultItem.item.id"
						class="searchResults__item"
					>
						<div class="container">
							{{ searchResultItem.item.name }}
						</div>
					</div>
				</template>
				<template v-else>
					<div class="container">
						{{ $t("Nenhum resultado encontrado para") }}:
						<span class="italic">“{{ searchStr }}”</span>
					</div>
				</template>
			</div>
		</div>
		<div class="simulationCards">
			<div class="container">
				<div
					class="projectSimulations"
					v-for="project in projects"
					:key="project"
				>
					<div class="projectSimulations__projectName">{{ project }}</div>
					<div class="projectSimulations__list">
						<SimulationCard
							v-for="simulation in simulationsByProject[project]"
							:summary="simulation"
							:key="simulation.id"
							class="simulationCard"
						>
						</SimulationCard>
					</div>
				</div>

				<div v-if="0" class="text-center">
					<BBtn size="l" variant="text">{{ $t("Carregar Mais") }}</BBtn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { groupBy, isNil } from "@/utils";

import Fuse from "fuse.js";

import BBtn from "@/components/base/BBtn";
import BIcon from "@/components/base/BIcon";
import SimulationCard from "@/components/SimulationCard";

export default {
	components: {
		BBtn,
		BIcon,
		SimulationCard,
	},

	data() {
		return {
			fuse: null,
			searchStr: "",
			searchResults: [],
		};
	},
	computed: {
		...mapState("simulations", ["simulations", "simulationSummaries"]),

		simulationsByProject() {
			return groupBy(
				this.simulationSummaries,
				(item) => item.metadata.projectName
			);
		},

		projects() {
			return Object.keys(this.simulationsByProject);
		},

		autoComplete() {
			return "";
			//return this.searchResults.length ? this.searchResults[0].item.name : "";
		},
	},
	methods: {
		isNil,
		...mapActions("simulations", ["fetchSimulationSummaries"]),
	},
	watch: {
		searchStr(searchStr) {
			this.searchResults = this.fuse.search(searchStr).slice(0, 10);
		},
	},
	created() {
		this.fetchSimulationSummaries().then(() => {
			this.fuse = new Fuse(this.simulationSummaries, {
				keys: ["name", "simulationType"],
			});
		});
	},
};
</script>

<style scoped lang="scss">
.simulationsSearch {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
}
.searchArea {
	padding-block: 117px 60px;
	background-color: var(--color-neutral-50);
}

.searchInputWrapper {
	isolation: isolate;
	position: relative;
	margin-bottom: 10px;
}

.searchInput,
.searchInputAutoComplete {
	width: 100%;
	display: block;

	font-family: Inter;
	font-size: 36px;
	font-weight: 300;
	line-height: 1.11;
	padding-block: 11px;

	border-bottom: 1px solid currentColor;
}

.searchInput {
	color: var(--color-primary-600);

	&::placeholder {
		color: var(--color-primary-600);
	}
}

.searchInputAutoComplete {
	position: absolute;
	inset: 0;
	pointer-events: none;
	color: var(--color-primary-200);
	z-index: -1;
}

.searchInputBtnIconBox {
	position: absolute;
	right: 18px;
	top: 0;
	bottom: 0;
	margin: auto;
	display: flex;
	align-items: center;
	gap: 40px;
}

.searchInputIcon {
	color: var(--color-neutral-600);
}

.searchResults {
	margin-top: 40px;
}

.searchResults__item {
	color: var(--color-neutral-900, #0e0f11);

	font-size: 16px;
	font-weight: 400;
	line-height: 1.25;
	padding-block: 10px;

	cursor: pointer;

	&:hover {
		background: var(--color-neutral-100, #e3e5e8);
	}
}

.totalResults {
	color: var(--color-neutral-600, #575b66);
	font-family: Inter;
	font-size: 16px;
	font-weight: 400;
	line-height: 1.25;
}

.simulationCards {
	flex-grow: 1;
	background-color: var(--color-neutral-100);
	padding-block: 40px 160px;
}

.projectSimulations {
	margin-bottom: 40px;
}

.projectSimulations__projectName {
	margin-bottom: 10px;
	color: var(--colors-neutral-n-600, #575b66);

	font-family: Inter;
	font-size: 16px;
	font-weight: 400;
	line-height: 1.25;
}

.simulationCard:not(:last-child) {
	margin-bottom: 2px;
}

@media (max-width: 768px) {
	.searchArea {
		padding-block: 60px 40px;
	}

	.searchInput,
	.searchInputAutoComplete {
		font-size: var(--font-size-m);
		font-weight: var(--font-weight-medium);
	}
}
</style>
